import React, { useState, useEffect } from 'react'
import { Document, Page, pdfjs } from "react-pdf";
import { Box } from "@mui/material";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import ErrorBoundary from '../ErrorBoundary';
import GoogleDocPDFViewer from './GoogleDocPDFViewer';
import { useTimeoutHit } from '../../hooks/useTimeoutHit';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
  wasmUrl: '/wasm/',
};


export function PDFViewer({ url, onLoadSuccess, ggDocIframeStyle }) {
  const [numPages, setNumPages] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [reactPdfError, setReactPdfError] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { timeoutHit, resetTimeoutHit } = useTimeoutHit(5000);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setLoaded(false);
    setReactPdfError(false);
    resetTimeoutHit();
  }, [url]);

  function onReactPdfLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
    setLoaded(true);
    setReactPdfError(false);

    if (onLoadSuccess) onLoadSuccess();
  }

  function onReactPdfLoadError(error) {
    setReactPdfError(true);
  }

  const onGoogleDocViewLoad = () => {
    if (onLoadSuccess) onLoadSuccess();
  };

  // Step 2: Google Docs viewer (fallback from react-pdf)
  const showGoogleDocViewer = (timeoutHit && !loaded) || reactPdfError;
  if (showGoogleDocViewer) {
    return (
      <GoogleDocPDFViewer 
        url={url}
        onLoad={onGoogleDocViewLoad}
        iframeStyle={ggDocIframeStyle}
      />
    );
  }

  // Step 1: React-PDF (primary method)
  return (
    <ErrorBoundary fallback={<GoogleDocPDFViewer url={url} onLoad={onGoogleDocViewLoad} iframeStyle={ggDocIframeStyle} />}>
      <Box textAlign="center" p={loaded ? 0 : 1}>
        <Document key={url} file={url} onLoadSuccess={onReactPdfLoadSuccess} onLoadError={onReactPdfLoadError} options={options}>
          {Array.from(Array(numPages), (_el, index) => (
            <Box key={`page_${index + 1}`} mb={1} display="flex" justifyContent="center">
              <Page
                pageNumber={index + 1}
                width={Math.min(windowWidth - 40, 800)}
              />
            </Box>
          ))}
        </Document>
      </Box>
    </ErrorBoundary>
  );
}